import { AfterViewInit, Component, Input, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatStep, MatStepper } from '@angular/material/stepper';

import { Observable, map } from 'rxjs';
import { Cutout } from '../../../../../models/cutting/cutting-panel-outline.model';
import { CuttingPanel } from '../../../../../models/cutting/cutting-panel.model';
import { CuttingStandardCutout } from '../../../../../models/cutting/cutting-standard-cutout.model';
import { CutoutAdderComponent } from './cutout-adder/cutout-adder.component';

@Component({
  templateUrl: './plate-cutout-wizard-dialog.component.html',
  styleUrls: ['./plate-cutout-wizard-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PlateCutoutWizardDialogComponent implements AfterViewInit {
  // tempPanel: CuttingPanel;
  panelOrign: CuttingPanel;

  @Input() set panel(val: CuttingPanel) {
    this.panelOrign = val;
    // this.tempPanel = _.cloneDeep(val);
  }
  @Input() groupId: number;

  @ViewChild(MatStepper, { static: true }) stepper: MatStepper;
  @ViewChild('schemaListStep', { static: true }) schemaListStep: MatStep;
  @ViewChild('adderStep', { static: true }) adderStep: MatStep;

  @ViewChild('cutoutAdder', { static: true }) cutoutAdder: CutoutAdderComponent;

  isInvalid$: Observable<boolean>;

  constructor(public dialogRef: MatDialogRef<PlateCutoutWizardDialogComponent>) {}

  ngAfterViewInit(): void {
    this.isInvalid$ = this.cutoutAdder.stateChanged$.pipe(map(res => !res));
  }

  getCoord(): Cutout {
    const cutout = this.cutoutAdder.cutout;
    return cutout;
  }

  skipStep(): void {
    this.schemaListStep.completed = true;
    this.stepper.next();
  }

  standardSelectChange(item: CuttingStandardCutout): void {
    if (item) {
      this.cutoutAdder.schema = item;
    }
    this.skipStep();
  }
}
